import flatten from 'flat'

import home from './home'

const messages = { home }

export default flatten(messages)
